import React from 'react';
import { motion } from 'framer-motion';
export function Welcome() {
  return <section className="py-24 px-6 border-y border-zinc-900 bg-zinc-950 relative overflow-hidden" data-id="element-125">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-126">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="font-serif text-3xl md:text-5xl lg:text-6xl leading-tight mb-8" data-id="element-127">
          Welcome to <span className="text-magenta-500" data-id="element-128">Dance for Fans</span> —
          the bold new platform giving OnlyFans a run for its money.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="text-lg md:text-2xl text-zinc-400 font-light italic font-serif" data-id="element-129">
          Your next-level destination for exclusive content, uniquely tailored
          for the ultimate fans.
        </motion.p>
      </div>
    </section>;
}